"use strict";
/**
 * @module Services.Timeseries
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a RANGE_QUERY request.
 */
var RangeQueryRequest = /** @class */ (function () {
    /**
     * Create a new RangeQueryRequest instance
     *
     * @param topicPath  the topic path
     * @param parameters  the range query parameters
     */
    function RangeQueryRequest(topicPath, parameters) {
        this.topicPath = topicPath;
        this.parameters = parameters;
    }
    return RangeQueryRequest;
}());
exports.RangeQueryRequest = RangeQueryRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/timeseries/range-query-request.js
// module id = 2025
// module chunks = 1